import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from './rootReducer'
import { setGlobalStore } from './globalStore'

export const makeStore = (deps, preloadedState) => {
	const store = configureStore({
		reducer: rootReducer,
		preloadedState,
		devTools: process.env.NODE_ENV !== 'production',
		middleware: getDefaultMiddleware =>
			getDefaultMiddleware({
				thunk: {
					extraArgument: deps,
				},
				immutableCheck: false,
				serializableCheck: false,
			}),
	})

	setGlobalStore(store)

	return store
}
